import mixpanel from "mixpanel-browser";
import Statsig from "statsig-js";
import config from "../../config";

class Analytics {
  constructor() {
    this.statsigInitialized = false;
    mixpanel.init(config.mixPanelKey, {
      debug: true,
      ignore_dnt: true,
    });
    this.initializeStatsig();
  }

  async initializeStatsig() {
    try {
      await Statsig.initialize(config.statsigKey, null, {
        environment: { tier: config.environment },
      });
      this.statsigInitialized = true;
    } catch (error) {
      console.error("Failed to initialize Statsig:", error);
    }
  }

  async updateUser(userId) {
    if (!userId) return;
    mixpanel.identify(userId);
    if (!this.statsigInitialized) {
      await this.initializeStatsig();
    }
    Statsig.updateUser({ userID: userId });
  }

  async track({ eventName, additionalProps = {} }) {
    if (!config.isEventTrackingEnabled) return;
    try {
      mixpanel.track(eventName, additionalProps);
      if (!this.statsigInitialized) {
        await this.initializeStatsig();
      }
      Statsig.logEvent(eventName, eventName, additionalProps);
    } catch (e) {
      console.error(e);
    }
  }

  trackPage(url) {
    try {
      if (config.isEventTrackingEnabled) {
        mixpanel.track_pageview({ page: url });
      }
    } catch (e) {
      console.error(e);
    }
  }
}

const analytics = new Analytics();

export default analytics;
